export enum DemographicValueType {
  HEIGHT_CM = 'HEIGHT_CM',
  WEIGHT_KG = 'WEIGHT_KG',
  GENDER = 'GENDER',
  AGE_DYNAMIC = 'AGE_DYNAMIC',
  AGE_STATIC = 'AGE_STATIC',
}
